// Modules
import { createAction, props } from '@ngrx/store';

// Interfaces
import { IAccidentDetail } from '@accidents/shared/interfaces/accidents';

// ----------- General Actions -----------
// ---------------------------------------
export const reset = createAction('[Detail Accident] - Reset');

export const getAccidentDetailRequested = createAction(
  '[Detail Accident] - Detail Accident Requested',
  props<{ payload: string }>()
);

export const getAccidentDetailResponse = createAction(
  '[Detail Accident] - Detail Accident Response',
  props<{ payload: IAccidentDetail }>()
);
